import { map } from 'lodash';
import React, { Fragment, useRef, useState, useCallback, useEffect } from 'react';
import { translate } from '../Services/translation';
import {useSelector } from "react-redux";



const NavigationItemDesktop = ({ links = [], contentLink = null, isWorkWearCustomer, budgetRemaining, workWearText, workWearLink, isExcludedFromBudget }) => {
    const [level1, setLevel1] = useState([])
    const [level2, setLevel2] = useState([]);
    const [showMegaMenu, setShowMegaMenu] = useState(false);
    const [show2MegaMenu, set2MegaMenu] = useState(false);
    const [currentLevel0, setCurrentLevel0] = useState(-1)
    const [currentLevel1, setCurrentLevel1] = useState(-1)
    const [isLoggedIn] = useState(window.__litium.preloadState.myPage.isBusinessCustomer)
    const [showSpinner, setShowSpinner] = useState(true);
    
    //timer on budget-spinner. simulate a short loading time to avoid flickering
    useEffect(() => {
        let timer;
        if (typeof isExcludedFromBudget !== 'undefined') {
            timer = setTimeout(() => setShowSpinner(false), 1000);
        }
        return () => clearTimeout(timer);
    }, [isExcludedFromBudget]);

    const refLevel0 = useRef()

    const checkLevel0 = (e, index, data) => {
        e.preventDefault();
        setLevel1(data.links[index].links)
        if(data.links[index].links.length > 0){
            setShowMegaMenu(true);
            set2MegaMenu(true)
            preRenderMenu(data.links[index].links[0])
        }
        if(data.links[index].links.length == 0){
            setShowMegaMenu(false);
        }
        //set active class level 0
        setCurrentLevel0(index)
    }

    const preRenderMenu = (data) =>{
        setCurrentLevel1(0)
        setLevel2(data.links);
    }

    const checkLevel1 = (e, index, data) => {
        e.preventDefault();

        setLevel2(data.links)
        
        //set active class level 1
        setCurrentLevel1(index)
    }

   useEffect(() => {
    const closeMegaMenu =(e) => {
        setShowMegaMenu(false)
        setCurrentLevel0(-1)
    }

    let navbar = document.querySelector(".navbar");
    navbar.addEventListener('mouseleave', closeMegaMenu);
    return() => {
        navbar.removeEventListener('mouseleave', closeMegaMenu)
    }
    },[])

    useEffect(() => {
        if(isWorkWearCustomer){
            document.body.classList.add("is-workwear")
        } 
    },[isWorkWearCustomer])

    const NavContainer = ({children}) =>{
        return (
            <>
                {children}
            </>
        )
    }

    const MegaMeny = () =>{
        return (
            <Level1 links={level1} />
        )
    }
    const SecondMegaMeny = () =>{
        return (
            <Level2 links={level2} />
        )
    }

    const ResetHoverEffect = () => {
        setCurrentLevel0(0)
    }

    const Level0 = (data) => {
        return (
            <>
                <div ref={refLevel0} className="nav__level0">
                    <ul className="header-buttons">
                        {workWearText !== "" && workWearLink !== "" && (
                            <li key="workWearLink" className="caret-icon-down header-buttons"> 
                                <a href={workWearLink} className='header-buttons__workwear' onMouseOver={(e) => {ResetHoverEffect()}}>{workWearText}</a>
                            </li>    
                        )}
                        {data.links.length > 0 && data.links.map((a, index) => {
                            if (!(isWorkWearCustomer && index === 0)) {
                                return (
                                    <React.Fragment key={index}>
                                        <li className={`${currentLevel0 === index ? 'active' : ''} ${a.links.length > 0 ? 'caret-icon-down' : ''}  header-button`} data-name={a.name} onMouseOver={(e) => { checkLevel0(e, index, data); }}>
                                            <a href={a.url}>{a.name}</a>
                                        </li>
                                    </React.Fragment>
                                );
                            }
                            return null;
                        })}
                    </ul>
                    {isLoggedIn && isWorkWearCustomer && (
                        <div className="navbar__budget">
                            <p>{translate('code.header.budget.info.text')} </p>
                            {showSpinner ? (
                                <div className='spinner spinner--small'></div>
                            ) : (
                                <span> 
                                    {budgetRemaining} {translate('code.currency.short.text')} 
                                </span>
                            )}
                        </div>
                    )}
                </div>
            </>
        );
    }

    const Level1 = (level1) => {
        return (
            <div className='nav__level1'>
               <ul>
                    {level1.links.map((data, index)=> {
                        return(
                        <li key={index} className={ `${ currentLevel1 == index ? 'active' :''} list`} onMouseOver={(e) => {checkLevel1(e, index, data);}}>
                            <a href={data.url}> {data.name}</a>
                        </li>
                    )
                    })}
                </ul>
            </div>
        )
    }

    const Level2 = (level2) => {
        return (
            <div className='nav__level2'>
                {level2.links.length > 0  && level2.links.map((data, index)=> {
                    return(
                    <div key={index} className="child">
                        <h4 className='level2__header'><a href={data.url}> {data.name}</a></h4>
                        <ul>
                        {data.links.length > 0 && data.links.map((data2, index2) => {
                            return(
                            <li key={index + "_" + index2}>
                                <a href={data2.url}>
                                {data2.name}
                                </a>
                            </li>
                            )
                        })}
                        </ul>
                    </div>
                   )
                })}
            </div>
        )
    }

return (
    <NavContainer>
        <Level0 links={links} />
            {showMegaMenu && (
                <div className='mega-container-flex' >
                    <div className='mega-child row--padding'>
                        <MegaMeny />
                        {show2MegaMenu &&(
                        <SecondMegaMeny />
                        )}
                    </div>
                </div>
            )}
    </NavContainer>
    )

}
export default NavigationItemDesktop;